import { useEffect, useState } from 'react';
import { deleteCookie, getCookie } from 'cookies-next';

import { CMS_OVERRIDES_COOKIE } from '@/utils/constants/common';
import { CMSOverridesCookieStringToObject } from '@/utils/devtools/cookie-utils';

import styles from './CMSOverrideCookie.module.css';

export default function CMSOverride() {
    const [overrides, setOverrides] = useState({});

    useEffect(() => {
        const cookieData = getCookie(CMS_OVERRIDES_COOKIE);
        if (!cookieData) {
            setOverrides({});
        }

        setOverrides(CMSOverridesCookieStringToObject(cookieData as string));
    }, []);

    if (Object.keys(overrides).length === 0) {
        return (
            <div className={styles.infoContainer}>
                No currently active CMS overrides found.
                <span>
                    E.g. <code>document.cookie=&quot;CMS=FOO~true!BAR~false; path=/;&quot;</code>
                </span>
            </div>
        );
    }

    return (
        <div className={styles.infoContainer}>
            Currently active CMS overrides:
            <ul className={styles.cookieList}>
                {Object.keys(overrides).map((key) => {
                    const value = overrides[key as keyof typeof overrides];
                    return (
                        <li key={key}>
                            <strong>{key}:</strong> {value}
                        </li>
                    );
                })}
            </ul>
            <button
                className={styles.button}
                onClick={() => {
                    deleteCookie(CMS_OVERRIDES_COOKIE);
                    setOverrides({});
                }}>
                Clear all overrides
            </button>
        </div>
    );
}
